import type {CreateExtensionArgument} from '@wix/document-manager-core'
import type {BuilderEditorClientSpecMapEntry, ComponentInCsm, BuilderComponentInCsm} from '@wix/document-services-types'
import _ from 'lodash'

export const isBlocksEditor = (createExtensionArgument?: CreateExtensionArgument) =>
    createExtensionArgument?.dsConfig?.origin === 'responsiveBlocks'

interface BuilderComponentInfo {
    compType?: string
    refType?: string
}

type BuilderCompatibleComponent = ComponentInCsm | BuilderComponentInCsm

export const extractBuilderComponentInfo = (component: BuilderCompatibleComponent): BuilderComponentInfo => {
    const {type} = component

    switch (type) {
        case 'EDITOR_REACT_COMPONENT':
            return {
                compType: _.get(component, ['data', 'type'])
            }
        case 'STUDIO_WIDGET':
            return {
                compType: _.get(component, ['data', 'componentModel', 'componentType'])
            }
        case 'PAGE':
        case 'WIDGET':
        case 'PAGE_OUT_OF_IFRAME':
        case 'WIDGET_OUT_OF_IFRAME': {
            const refType = _.get(component, ['data', 'refType'])
            const componentType = _.get(component, ['data', 'componentType'])
            return refType && componentType ? {compType: componentType, refType} : {}
        }
        default:
            return {}
    }
}

const hasValidBuilderComponent = (component: BuilderCompatibleComponent): boolean =>
    !!extractBuilderComponentInfo(component).compType

export const hasBuilderComponents = (application: BuilderEditorClientSpecMapEntry) =>
    application.components?.some(component => hasValidBuilderComponent(component))
